import type { MixShare } from "@/config/mixLineup";
import type { SettingsEvent } from "@/features/settings/mediators/settingsEvents";
import { MIX_SHARE_PERCENTS } from "@/features/settings/stores/mixStore";
import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";

export type MixSettingsEvent = Extract<
  SettingsEvent,
  { type: "settings/mix-board-share-changed" }
>;

export interface MixSettingsEffect {
  readonly slug: string;
  readonly share: MixShare;
}

export function createMixSettingsMediator(
  getCurrentShare: (slug: string) => MixShare,
  runEffect: (effect: MixSettingsEffect) => void,
): Mediator<null, MixSettingsEvent, MixSettingsEffect> {
  return createMediator<null, MixSettingsEvent, MixSettingsEffect>(
    null,
    (state, event) => {
      const fallback = getCurrentShare(event.slug);
      const share =
        event.value === "uncapped"
          ? "uncapped"
          : (MIX_SHARE_PERCENTS.find(
              (percentage) => String(percentage) === event.value,
            ) ?? fallback);
      return {
        status: "handled",
        state,
        effects: [{ slug: event.slug, share }],
      };
    },
    { runEffect },
  );
}
